import { VisitHistory, VisitHistoryQuery } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsInfiniteQuery } from '@dreryk/command-query-react-common';
import {
   InfiniteListData,
   InfiniteListLoadMoreAvailable,
   InfiniteListLoadMoreFunction,
   LoaderSpinner,
   NotFoundPanel,
} from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { VisitHistoryShowAnnulledCheckbox } from './VisitHistoryShowAnnulledCheckbox/VisitHistoryShowAnnulledCheckbox';

type VisitHistoryInfiniteListLoaderResult = {
   visitHistoryPages: InfiniteListData<VisitHistory>;
   fetchNextVisitHistoryPage: InfiniteListLoadMoreFunction;
   nextVisitHistoryPageAvailable: InfiniteListLoadMoreAvailable;
};

type VisitHistoryInfiniteListLoaderProps = {
   readonly patientId: number;
   readonly children: (result: VisitHistoryInfiniteListLoaderResult) => JSX.Element;
};

export const VisitHistoryInfiniteListLoader = (props: VisitHistoryInfiniteListLoaderProps): JSX.Element => {
   const [includeAnnulled] = VisitHistoryShowAnnulledCheckbox.useAnnulledVisitsVisibilityPreferenceGlobalState();

   const {
      pages: visitHistoryPages,
      loading: visitHistoryLoading,
      error: visitHistoryError,
      fetchNext: fetchNextVisitHistoryPage,
      nextAvailable: nextVisitHistoryPageAvailable,
   } = useCqrsInfiniteQuery<VisitHistory>(
      () => {
         const query = new VisitHistoryQuery();
         query.patientId = Slot.emptyIfNull(props.patientId);
         query.includeAnnulled = includeAnnulled;
         return query;
      },
      {
         limit: 10,
      }
   );

   if (visitHistoryLoading) {
      return <LoaderSpinner />;
   }

   if (!visitHistoryPages || visitHistoryError) {
      return <NotFoundPanel />;
   }

   return props.children({
      visitHistoryPages: visitHistoryPages,
      fetchNextVisitHistoryPage: fetchNextVisitHistoryPage,
      nextVisitHistoryPageAvailable: nextVisitHistoryPageAvailable,
   });
};
